export default __webpack_public_path__ + "static/media/headUltrasonic.da87f3ee.svg";